import React from 'react';
import { useSelector } from 'react-redux';

import { getAddressByStr } from '@r1-frontend/entities/ContactAddress/selectors/helpers';

import { CallCalling } from '@r1-frontend/ui-react/components/svg/call';
import { Location } from '@r1-frontend/ui-react/components/svg/location';
import { User } from '@r1-frontend/ui-react/components/svg/users';

import InfoBlock from '~/src/features/full-buy/InfoBlock'; // @todo отвязаться от full-buy
import InfoBlockItem from '~/src/features/full-buy/InfoBlock/Item'; // @todo отвязаться от full-buy
import { getClientPersonalAddressStr } from '~/src/features/managementAgreement/selectors/helpers/getClientPersonalAddressStr';
import { useCtxSelector } from '~/src/features/tariffBuilder/hooks';
import getPhone from '~/src/features/tariffBuilder/selectors/getPhone';
import selectClientName from '~/src/features/tariffBuilder/selectors/selectClientName';
import selectCurrentTariff from '~/src/features/tariffBuilder/selectors/selectCurrentTariff';
import { TState } from '~/src/store';


const AgreementInfoContainer = () => {
    const { address, clientPersonalAddress, clientPersonalFio } = useSelector((state:TState) => ({
        address: state.contactAddress.verifiedAddressData.address,
        clientPersonalAddress: state.auth.clientPersonal?.address,
        clientPersonalFio: state.auth.clientPersonal?.fio,
    }));

    const { agreementNumber, phone, currentTariff, clientName } = useCtxSelector((state) => ({
        agreementNumber: state.agreement.agreementNumber,
        phone: getPhone(state),
        clientName: selectClientName(clientPersonalFio)(state),
        currentTariff: selectCurrentTariff(state),
    }));

    return (
        <InfoBlock
            title={agreementNumber ? `Заявка № ${agreementNumber}` : 'Ваши данные'}
            header={'Информация'}
            isCollapsable={true}
            isRightSide={true}
            customStyles={{
                wrapper: 'margin-bottom: 40px;',
            }}
        >
            <InfoBlockItem
                icon={<User size={24}/>}
                title={'ФИО'}
                content={clientName}
            />
            <InfoBlockItem
                icon={<CallCalling size={24}/>}
                title={'Номер телефона'}
                content={phone}
            />
            <InfoBlockItem
                icon={<Location size={24}/>}
                title={currentTariff ? 'Адрес доставки' : 'Адрес подключения'}
                content={currentTariff ? getClientPersonalAddressStr(clientPersonalAddress) : getAddressByStr(address)}
            />
        </InfoBlock>
    );
};

export default AgreementInfoContainer;
